import { render } from "./recruitment.vue?vue&type=template&id=78d3a208&scoped=true"
import script from "./recruitment.vue?vue&type=script&lang=js"
export * from "./recruitment.vue?vue&type=script&lang=js"

import "./recruitment.vue?vue&type=style&index=0&id=78d3a208&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d3a208"]])

export default __exports__